<div style="padding: 0 25px" class="header header-fixed d-flex align-items-stretch justify-content-between">
  <!--begin::Header Menu Wrapper-->
  <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
    <!--begin::Header Logo-->
    <div class="header-logo">
      <a routerLink="/">
        <img alt="Logo" src="./assets/media/logos/logo_inside.png" loading="lazy" decoding="async">
      </a>
    </div>
  </div>
</div>

<div style="margin-top: 80px">

  <div *ngIf="!(rules$ | async)?.length && !loading; else rulesContent" class="card card-custom gutter-b">
    <div class="card-header">
      <div class="card-title">
        <h3 class="card-label">Reference files for Rule ID: <span class="label label-lg label-inline label-light-primary">{{id}}</span></h3>
      </div>
    </div>
    <div class="card-body">
      No Reference files found.
    </div>
  </div>
  <ng-template #rulesContent>
    <div  class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">Reference links for Rule ID: <span class="label label-lg label-inline label-light-primary">{{id}}</span></h3>
        </div>
      </div>
      <div *ngIf="!(rules$ | async)?.length && loading" class="card-body">
        Loading...
      </div>
      <div *ngIf="(rules$ | async)?.length" class="card-body">
        <table class="table align-middle table-nowrap mb-0">
          <thead class="table-active">
          <tr>
            <th>Name</th>
            <th>Note</th>
            <th>Download</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let item of rules$ | async">
            <td class="file-name">
              <div class="d-flex align-items-center">
                <div class="d-flex fs-17 me-2">
                  <i [class]="getIconClass(item.originalName)" class="align-bottom"></i>
                </div>
                <div>
                  <p>{{ item.originalName }}</p>
                  <p style="font-size: 10px; color: #b2b9c1;">{{ item.uploadDate | date : 'dd-MM-yyyy' }}</p>
                </div>
              </div>
            </td>
            <td class="file-details">
              <div class="text-wrap">{{ item.note }}</div>
            </td>
            <td>
              <a href="{{API_URL}}/rule-files/{{ item.id }}"
                 class="btn btn-icon2 btn-light btn-hover-primary  mx-3" target="_blank" title="Download">
                  <span [inlineSVG]="'./assets/media/svg/icons/Download.svg'" class="svg-icon svg-icon-primary"
                        style="margin: 0; width: 15px; height: 15px;"></span>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

    </div>
  </ng-template>
</div>
